<div class="container py-3">

  <!-- Top bar: type selector + add type button -->
  <div class="d-flex align-items-center gap-3 flex-wrap mb-2">
    <app-searchable-select
      class="col-md-4"
      [options]="typeList$ | async"
      [selectedValue]="selectedType"
      [displayWithFn]="displayType"
      [label]="'Select Type'"
      [placeholder]="'Select Type'"
      (selectionChange)="onTypeSelect($event)"
    ></app-searchable-select>

    <button permission="Types" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]"
            mat-raised-button color="accent"
            (click)="AddType()">
      <mat-icon>add</mat-icon> Add Type
    </button>
  </div>

  <hr>

  <!-- Add value row — only shown when a type is selected -->
  <ng-container *ngIf="selectedType">
    <div class="d-flex align-items-center gap-3 flex-wrap mb-2" [formGroup]="fieldForm">
      <mat-form-field appearance="outline" style="min-width: 280px;">
        <mat-label>Enter {{ selectedType }} Value</mat-label>
        <input matInput formControlName="field">
        <mat-error *ngIf="fieldForm.get('field')?.errors?.['required']">This field is required.</mat-error>
      </mat-form-field>

      <button permission="Types" [permissionTypes]="[PermissionType.ADD]"
              mat-raised-button color="primary"
              type="submit"
              (click)="AddTypData()">
        <mat-icon>add</mat-icon> Add to {{ selectedType }}
      </button>
    </div>
    <hr>
  </ng-container>

  <!-- Table section -->
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>{{ selectedType ? selectedType + ' Types' : 'Types' }}</h2>
      </li>
    </ul>
    <ul class="header-buttons mr-2"></ul>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button permission="Types" [permissionTypes]="[PermissionType.EDIT]"
                  mat-icon-button color="primary"
                  matTooltip="Edit"
                  (click)="Edit(row)">
            <mat-icon>edit</mat-icon>
          </button>
          <button permission="Types" [permissionTypes]="[PermissionType.ARCHIVE]"
                  mat-icon-button color="warn"
                  matTooltip="Delete"
                  (click)="Delete(row.key)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-4" colspan="2">
          <ng-container *ngIf="!selectedType">
            <mat-icon color="primary">arrow_upward</mat-icon>
            Select a type above to view its values.
          </ng-container>
          <ng-container *ngIf="selectedType">
            No values found for <strong>{{ selectedType }}</strong>. Add one above.
          </ng-container>
        </td>
      </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[25, 50, 100, 200, 500]"
                   aria-label="Select page"></mat-paginator>
  </div>

</div>